import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import Markdown from "@components/Markdown"

const MetaBanner = ({ header, contentText, theme, inverted, pathname }) => {
  let color = "",
    background = ""
  switch (theme) {
    case "blue-bg":
      color = inverted ? "text-dblue" : "text-white"
      background = inverted ? "bg-white" : "bg-dblue"
      break
    case "white-bg":
      color = inverted ? "text-white" : "text-dblue"
      background = inverted ? "bg-dblue" : "bg-white"
      break
    case "gray-bg":
      color = "text-dblue"
      background = "bg-gray"
      break
  }

  return (
    <section
      className={`
        relative 
        ${color} 
        ${background} 
        px-6 
        py-8
        md:py-7.5
        md:pr-16
        desk:py-9
        desk:px-25
        mx-auto
        max-w-screen-fhd
      `}
      role="alert"
    >
      <div className="md:pr-1 desk:pr-4 desk:max-w-[918px] fhd:max-w-[1218px]">
        <h3 className="text-xl leading-6 desk:text-3xl fhd:text-[40px] fhd:leading-[48px] font-sans font-normal mb-3 desk:mb-4">
          {header}
        </h3>
        <div
          className={`text-sm desk:text-base fhd:text-xl ${color}/70 font-normal font-sans m-0`}
        >
          <Markdown>{contentText}</Markdown>
        </div>
      </div>
      <Link
        to={pathname}
        className="
          p-4
          md:p-6
          desk:p-12.5
          absolute 
          top-0
          md:top-1/2
          md:-translate-y-1/2
          right-0
        "
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 1.6L14.4 0L8 6.4L1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6Z"
            fill="currentColor"
          />
        </svg>
      </Link>
    </section>
  )
}

MetaBanner.propTypes = {
  header: PropTypes.string,
  contentText: PropTypes.string,
  onClose: PropTypes.func,
}

MetaBanner.defaultProps = {
  header: "Header",
}

export default MetaBanner